module.exports = __webpack_public_path__ + "static/media/logo_sell_buy_real_estate.1a9b0834.png";